<template>
    <b-form-group
        :label="dayTitle"
        label-for="edit_location_hour_day">        
        <b-form-tags
            input-id="edit_location_hour_day"
            tag-variant="info"
            tag-pills
            size="lg"
            v-model="day"
            required  >
                <template v-slot="{tags, tagVariant, removeTag}">        
                    <ul class="list-unstyled p-0 m-0 d-flex flex-wrap align-items-center">
                        <li class="align-items-baseline mw-100"
                            v-for="(tag, index) in tags" :key="index">
                            <b-form-tag
                                pill
                                :variant="tagVariant"
                                @remove="removeTag(tag)"
                                :disabled="!wantEdit">
                                {{ getOutputHour(tag) }}
                            </b-form-tag>
                        </li>
                        <li class="flex-grow-1" v-if="wantEdit">
                            <b-form @submit="addTag" class="d-flex">
                                <b-form-input
                                    v-model="inputHour"
                                    class="flex-grow-1 p-0 m-0 bg-transparent border-0"
                                    placeholder="Add Hour..."
                                    size="sm" style="box-shadow: none;" />
                                <b-button type="submit" size="sm" variant="outline-secondary" >Add</b-button>
                            </b-form>
                        </li>
                    </ul>                                         
                </template>
        </b-form-tags>
        <span class="text-danger">{{error}}</span>
    </b-form-group>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
//Maximum 2359->23:59
const timeFormats = ["h:mma", "hh:mma", "h:mmA", "hh:mmA", "h:mm a", "hh:mm a", "h:mm A", "hh:mm A", "H:m"];
const displayFormat = "hh:mma";

export default {
    name : 'LocationHoursDay',
    components:{  },
    props : {
        dayTitle : { type : String },
        wantEdit : {type : Boolean, default : true},
        value : { type : Array },
    },
    data() { return { day : this.value , inputHour : "", error : ""} },
    computed : {
        ...mapState({ }),
    },
    watch : {
        day : {
            deep : true,
            immediate : true,
            handler(newValue) {
                this.$emit('input', newValue);
            }
        }
    },
    created() { 
    },
    destroyed() { },
    methods: {
        addTag(event) {
            event.preventDefault()
            try {
                const hours = this.inputHour.split("-");
                const stTime = moment(hours[0].trim(), timeFormats)
                const etTime = moment(hours[1].trim(), timeFormats)
                if(stTime.isValid() && etTime.isValid()) {      
                    const hour = { startTime : stTime.format(displayFormat), endTime : etTime.format(displayFormat) }
                    this.day.push(hour);
                    this.inputHour = "";
                    this.error = "";
                }else{
                    throw new Error("");
                }
            } catch(e) {
                this.error = "Invalid Format of adding TimeSlot";
            }
        },
        getOutputHour(hourString){
            try{
                const hour = JSON.parse(hourString);
                return hour.startTime && hour.endTime ? `${hour.startTime}-${hour.endTime}` : hourString
            }catch(_){
                return hourString
            }
        }
     },
}
</script>
<style scoped lang="scss">

</style>